import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import { Container } from "@mui/material";

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass
    {
      title: "Home",
      link: "#home",
    },
    {
      title: "About",
      link: "#about",
    },
    {
      title: "Features",
      link: "#features",
    },
  ];
  return (
    <div
      data-aos="fade-down"
      style={{ width: "100% !important", background: "#000" }}
    >
      <Container>
        <Container>
          <DesktopMenu menuList={menuList} />
          <MobileMenu menuList={menuList} />
        </Container>
      </Container>
    </div>
  );
};

export default LockerMenu;
